import "./SearchInput.css"

import { useState } from "react"
import classNames from "classnames"
import OutsideClickHandler from "react-outside-click-handler"

import { SelectX, Icon } from "web/components"

import { useSearch } from "web/hooks/data"

import {
  AssetIcon,
  CompanyIcon,
  DealIcon,
  PortfolioIcon,
  MapPinIcon,
} from "web/icons"

export default function SearchInput({
  scope = "all",
  onSelect,
  autoFocus = false,
  inputTestId,
}) {
  const [active, setActive] = useState(false)
  const search = useSearch(scope)

  const suggestionIcons = {
    asset: AssetIcon,
    company: CompanyIcon,
    deal: DealIcon,
    place: MapPinIcon,
    portfolio: PortfolioIcon,
  }

  async function getResults(query) {
    const results = await search(query)
    return results.map((result) => ({
      icon: result.type,
      ...result,
      key: `${result.type}-${result.value}`,
    }))
  }

  async function selectResult(result) {
    setActive(false)
    onSelect(result)
  }

  const classes = classNames("search-input", { active: active })

  return (
    <div className={classes}>
      <Icon name="magnifying-glass" outline="true" />
      <OutsideClickHandler onOutsideClick={() => setActive(false)}>
        <SelectX
          onChange={selectResult}
          onFocus={() => setActive(true)}
          onBlur={() => setActive(false)}
          validValues={getResults}
          suggestionIcons={suggestionIcons}
          options={{
            clearOnFocus: true,
            inputClassName: "form-control focus:ring-0",
            includeNullSuggestion: false,
            autoFocus,
            inputTestId,
          }}
        />
      </OutsideClickHandler>
    </div>
  )
}
